import { FETCH_GROUP_LESSON_AWARDS_SUCCESS } from './actions';
import { Map } from 'immutable';

export default function groupLessonAwards(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_GROUP_LESSON_AWARDS_SUCCESS: {
      const key = `${action.sessionId}`;
      if (! action.payload) return state.set(key, null);
      return state.set(key, action.payload);
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./data/GroupLessonAwards/reducer.js